/**
 * gufuyan
 * @content 滚动条组件
 * @date 2017-05-24 1.0版本
 */
import React, { Component } from 'react';

// const propTypes = {
//     // designationTheme: PropTypes.string,
//     // formType: PropTypes.string,
//     // inputName: PropTypes.string.isRequired,
//     // formText: PropTypes.string,
//     // disabled: PropTypes.bool,
//     // required: PropTypes.bool,
//     // hintText: PropTypes.string,
//     // textWidth: PropTypes.string,
//     // valueWidth: PropTypes.string,
//     // changeValue: PropTypes.func,
//     // errorText: PropTypes.string,
//     // dataType: PropTypes.string,
//     // // remarks  无规则 自定义传参
//     // // regex:PropTypes.number,//正则
//     // regexText: PropTypes.string,
// };

let styleData = {
    scrollBoxWrap: {
        position: "relative",
        overflow: "hidden",
        width: "20rem",
        maxHeight: "100rem",
        // border:"red solid 0.08rem",
    },
    scrollContentWrap: {
        zIndex: 1,
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        overflow: "auto scroll",//scroll
        
        // overflow:"auto",
        width: "20rem",
        maxHeight: "100rem",
        // border:"green solid 0.08rem",
    },
    //垂直滚动条容器
    verticalBarWrap: {
        position: "absolute",
        height: "100%",
        right: "0",
        top: "0",
        zIndex: 2,
        // border:"blue solid 0.08rem",
    },
    //横向滚动条容器
    horizontalBarWrap: {
        position: "absolute",
        width: "100%",
        left: "0",
        bottom: "0",
        zIndex: 2,
        // border:"pink solid 0.08rem",
    },
    //滚动条
    scrollBar: {
        position: "absolute",
        borderRadius: "0.25rem",
        cursor: "pointer",
        // border:"yellow solid 0.08rem",
    }
};

class ScrollBox extends Component {
    constructor(props) {
        super(props);

        // this.scrollContentWrap = ref => {this.refDom = ref};
        // this.scrollContent = ref => {this.refDom = ref};

        this.scrollContentWrap = React.createRef();
        this.scrollContent = React.createRef();

        this.state = {
            styleData,
            wrapHeight_1: 0,
            contentHeight_1: 0,
            scrollHeight_1: 0,
            mouseDown_1: false,//垂直滚动条是否被点击 false为否
            mouseDown_2: false,//横向滚动条是否被点击 false为否
            startPos_1: 0,
            startPos1_1: 0,

            botFixed_1: false,
            rigFixed_1: false,

            needVerticalBar: false,//是否需要垂直滚动条
            needHorizontalBar: false,//是否需要横向滚动条
            scrollBarTop: 0,
            scrollBarBot: 0,
            scrollBarLeft: 0,
            scrollBarRight: 0,

            realScrollBarWidth: 0,
            scrollBarWidth: 6,       // 滚动条宽度
            scrollWrapColor: this.props.scrollWrapColor || "white",// 滚动条容器背景颜色
            scrollBarColor: this.props.scrollBarColor || "rgb(231, 231, 231)"// 滚动条颜色
        };
    }


    scrollBarStateChange() {

        // let scrollContentWrap = this.refs.scrollContentWrap;
        // let scrollContent = this.refs.scrollContent;
        // let scrollContentWrap = this.scrollContentWrap;
        // let scrollContent = this.scrollContent;
        let scrollContentWrap = this.scrollContentWrap.current;
        let scrollContent = this.scrollContent.current;


        //垂直滚动条
        let wrapHeight = scrollContentWrap.clientHeight;
        let contentHeight = scrollContent.scrollHeight;
        if (contentHeight <= wrapHeight) {

        } else {
            let scrollHeight = (wrapHeight / contentHeight * 100).toFixed(2);
            let scrollTop = (scrollContentWrap.scrollTop / contentHeight * 100).toFixed(2);
            if (parseInt(this.state.scrollBarBot) == 0 && this.state.botFixed_1 == true) {
                scrollContentWrap.scrollTop = contentHeight;
                let scrollBarTop = 100 - (parseFloat(scrollHeight));
                let scrollBarBot = 0;
                this.setState({
                    scrollBarTop: scrollBarTop,
                    scrollBarBot: scrollBarBot,
                    needVerticalBar: true,
                    wrapHeight_1: wrapHeight,
                    contentHeight_1: contentHeight,
                    scrollHeight_1: scrollHeight,
                });
            } else {
                let scrollBarTop = parseFloat(scrollTop);
                let scrollBarBot = 100 - (parseFloat(scrollHeight) + parseFloat(scrollTop));
                this.setState({

                    scrollBarTop: scrollBarTop,
                    scrollBarBot: scrollBarBot,
                    needVerticalBar: true,

                    wrapHeight_1: wrapHeight,
                    contentHeight_1: contentHeight,
                    scrollHeight_1: scrollHeight,
                });
            }
        }

        //横向滚动条
        let wrapWidth = scrollContentWrap.clientWidth;//++
        let contentWidth = scrollContent.scrollWidth;//++
        if (contentWidth <= wrapWidth) {

        } else {

            let scrollWidth = (wrapWidth / contentWidth * 100).toFixed(2);//++
            let scrollLeft = (scrollContentWrap.scrollLeft / contentWidth * 100).toFixed(2);//++
            //++
            if (parseInt(this.state.scrollBarRight) == 0 && this.state.rigFixed_1 == true) {
                scrollContentWrap.scrollLeft = contentWidth;
                let scrollBarLeft = 100 - (parseFloat(scrollWidth));
                let scrollBarRight = 0;
                this.setState({
                    scrollBarLeft: scrollBarLeft,
                    scrollBarRight: scrollBarRight,
                    needHorizontalBar: true,
                    wrapWidth_1: wrapWidth,
                    contentWidth_1: contentWidth,
                    scrollWidth_1: scrollWidth,
                });
            } else {
                let scrollBarLeft = parseFloat(scrollLeft);
                let scrollBarRight = 100 - (parseFloat(scrollWidth) + parseFloat(scrollLeft));
                this.setState({
                    scrollBarLeft: scrollBarLeft,
                    scrollBarRight: scrollBarRight,
                    needHorizontalBar: true,

                    wrapWidth_1: wrapWidth,
                    contentWidth_1: contentWidth,
                    scrollWidth_1: scrollWidth,
                });
            }
        }


    }

    handleScroll() {
        // let scrollContentWrap = this.scrollContentWrap;
        let scrollContentWrap = this.scrollContentWrap.current;

        let scrollBarTop = (scrollContentWrap.scrollTop / this.state.contentHeight_1 * 100);
        let scrollBarBot = 100 - (parseFloat(this.state.scrollHeight_1) + parseFloat(scrollBarTop));

        let scrollBarLeft = (scrollContentWrap.scrollLeft / this.state.contentWidth_1 * 100);//++
        let scrollBarRight = 100 - (parseFloat(this.state.scrollWidth_1) + parseFloat(scrollBarLeft));//++
        this.setState({
            scrollBarTop: scrollBarTop.toFixed(2),
            scrollBarBot: scrollBarBot.toFixed(2),

            scrollBarLeft: scrollBarLeft.toFixed(2),//++
            scrollBarRight: scrollBarRight.toFixed(2),//++
        });
        var requestFlag = this.props.requestFlag || false;
        if (scrollBarBot <= 5 && requestFlag) {
            this.props.requestDataBack ? this.props.requestDataBack() : null;
        }
        // if (scrollBarRight <= 5 && requestFlag) {
        //     this.props.requestDataBack ? this.props.requestDataBack() : null;
        // }
    }

    handleMouseMove(e) {
        // e.preventDefault();
        // e.stopPropagation();

        // let scrollContentWrap = this.scrollContentWrap;
        let scrollContentWrap = this.scrollContentWrap.current;
        if (this.state.mouseDown_1) {
            let startPos = this.state.startPos_1;
            let changePos = startPos - e.clientY;
            this.setState({
                startPos_1: e.clientY,
            });
            scrollContentWrap.scrollTop -= (changePos * this.state.contentHeight_1 / this.state.wrapHeight_1);
        } else if (this.state.mouseDown_2) {
            let startPos1 = this.state.startPos1_1;//++
            let changePos1 = startPos1 - e.clientX;//++
            this.setState({
                startPos1_1: e.clientX//++
            });

            scrollContentWrap.scrollLeft -= (changePos1 * this.state.contentWidth_1 / this.state.wrapWidth_1);//++
        }
    }

    handleMouseUp() {
        if (this.state.mouseDown_1) {
            this.setState({
                mouseDown_1: false
            });
        } else if (this.state.mouseDown_2) {
            this.setState({
                mouseDown_2: false
            });
        }

    }

    handleMouseDown(e) {
        this.setState({
            mouseDown_1: true,
            startPos_1: e.clientY,
        });
    }

    handleMouseDown1(e) {
        this.setState({
            mouseDown_2: true,
            startPos1_1: e.clientX//++
        });
    }

    componentDidUpdate = () => {
        let shouldUpdate = this.props.shouldUpdate;
        if (shouldUpdate) {
            setTimeout(() => {
                this.scrollBarStateChange();
                this.props.initScroll();
            }, 100);
        }
    };

    componentWillMount() {
        let styleData = eval('(' + JSON.stringify(this.state.styleData) + ')');
        styleData.scrollBoxWrap.width = this.props.width || "20rem";
        styleData.scrollBoxWrap.maxHeight = this.props.maxHeight || "20rem";
        styleData.scrollContentWrap.width = this.props.width || "20rem";
        styleData.scrollContentWrap.maxHeight = this.props.maxHeight || "20rem";
        this.setState({
            styleData
        })
    }

    componentDidMount() {
        // 当页面渲染完成，获取滚动条的宽度，存起来
        // offsetWidth 返回元素的宽度（包括元素宽度、内边距和边框，不包括外边距）
        // clientWidth 返回元素的宽度（包括元素宽度、内边距，不包括边框和外边距）

        // let formBox = this.refDom;
        // let scrollContentWrap2 = this.refs.scrollContentWrap;
        // let scrollContentWrap = this.scrollContentWrap;

        // let styleData = eval('(' + JSON.stringify(this.state.styleData) + ')');

        let scrollContentWrap = this.scrollContentWrap.current;
        // let scrollBoxWrap = this. scrollBoxWrap.current

        // let acturalHeight  = this.scrollContentWrap.current.offsetHeight
        // let propsHeight = this.props.maxHeight.indexOf('rem') >= 0 ? parseFloat(this.props.maxHeight) * 16 : parseFloat(this.props.maxHeight);
        // let tempHeight = acturalHeight<propsHeight?acturalHeight/16+'rem':propsHeight/16+'rem'
        // styleData.scrollBoxWrap.height =tempHeight
        // styleData.scrollContentWrap.height = tempHeight

        let scrollBarWidth = scrollContentWrap.offsetWidth - scrollContentWrap.clientWidth;
        this.setState({
            realScrollBarWidth: scrollBarWidth,
            // styleData
        });

        if (this.props.botFixed) {
            this.setState({
                botFixed_1: this.props.botFixed === "true",
            });
        }
        if (this.props.rigFixed) {
            this.setState({
                rigFixed_1: this.props.rigFixed === "true",
            });
        }
        document.addEventListener("mouseup", this.handleMouseUp.bind(this));
        document.addEventListener("mousemove", this.handleMouseMove.bind(this));
    }

    render() {
        let style = this.state.styleData;

        //处理 内容的宽度  需加上滚动条的宽度 为的是隐藏原生滚动条
        let scrollContentWrap = eval('(' + JSON.stringify(style.scrollContentWrap) + ')');
        let scrContWidth = scrollContentWrap.width;
        let scrContHeight = scrollContentWrap.maxHeight;
        scrContWidth = scrContWidth.indexOf('rem') >= 0 ? parseFloat(scrContWidth) * 16 : parseFloat(scrContWidth);
        scrContHeight = scrContHeight.indexOf('rem') >= 0 ? parseFloat(scrContHeight) * 16 : parseFloat(scrContHeight);
        scrollContentWrap.width = (scrContWidth + (this.state.realScrollBarWidth)) / 16 + "rem";
        if (this.props.bottomScroll != "N") {//避免，当不需要底部滚动条时，高度也会加上滚动条高度，导致滚动到底部看不全
            scrollContentWrap.maxHeight = (scrContHeight + (this.state.realScrollBarWidth)) / 16 + "rem";
        }

        //垂直滚动条容器样式
        let verticalBarWrap = eval('(' + JSON.stringify(style.verticalBarWrap) + ')');
        verticalBarWrap.width = this.state.scrollBarWidth / 16 + "rem";
        verticalBarWrap.borderRadius = (this.state.scrollBarWidth / 2) / 16 + "rem";
        verticalBarWrap.backgroundColor = this.state.scrollWrapColor;
        //横向滚动条容器样式
        let horizontalBarWrap = eval('(' + JSON.stringify(style.horizontalBarWrap) + ')');
        horizontalBarWrap.height = this.state.scrollBarWidth / 16 + "rem";
        horizontalBarWrap.borderRadius = (this.state.scrollBarWidth / 2) / 16 + "rem";
        horizontalBarWrap.backgroundColor = this.state.scrollWrapColor;

        //垂直滚动条样式
        let scrollBar = eval('(' + JSON.stringify(style.scrollBar) + ')');
        scrollBar.top = this.state.scrollBarTop + "%";
        scrollBar.bottom = this.state.scrollBarBot + "%";
        scrollBar.left = 0;
        scrollBar.right = 0;
        scrollBar.backgroundColor = this.state.scrollBarColor;
        //横向滚动条样式
        let scrollBar1 = eval('(' + JSON.stringify(style.scrollBar) + ')');
        scrollBar1.left = this.state.scrollBarLeft + "%";
        scrollBar1.right = this.state.scrollBarRight + "%";
        scrollBar1.top = 0;
        scrollBar1.bottom = 0;
        scrollBar1.backgroundColor = this.state.scrollBarColor;

        let scrollBarDom = "";

        let scrollBar1Dom = "";

        //是否需要垂直滚动条
        if (this.state.needVerticalBar) {
            // if(this.state.scrollBarTop == 0 && this.state.scrollBarBot ==0){//判断竖向滚动条是否
            //
            // }else {
            scrollBarDom = (
                <div style={verticalBarWrap}>
                    <div onMouseDown={this.handleMouseDown.bind(this)} style={scrollBar}></div>
                </div>
            );
            // }

        } else {
            // verticalBarWrap.width = "0.5rem";
            // verticalBarWrap.backgroundColor = "white";
            // scrollBarDom = (<div style={verticalBarWrap}></div>);
        }

        //是否需要横向滚动条
        if (this.state.needHorizontalBar) {
            scrollBar1Dom = (
                <div style={horizontalBarWrap}>
                    <div onMouseDown={this.handleMouseDown1.bind(this)} style={scrollBar1}></div>
                </div>
            );
        } else {
            // horizontalBarWrap.height = "0.5rem";
            // horizontalBarWrap.backgroundColor = "white";
            // scrollBar1Dom = (<div style={horizontalBarWrap}></div>);
        }


        return (
            <div style={style.scrollBoxWrap}>
                {scrollBarDom}
                {this.props.bottomScroll == "N" ? null : scrollBar1Dom}
                <div ref={this.scrollContentWrap} style={scrollContentWrap} onScroll={this.handleScroll.bind(this)}>
                    <div ref={this.scrollContent}
                        style={{ display: 'inline-block',width:'100%'}}
                    //不加会出现，横向滚动算不出来，都是100%。
                    //加
                    >
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

// ScrollBox.propTypes = propTypes;

export default ScrollBox;
